<template>
  <div>
    <el-card style="margin: 30px;">
      <div style="display: flex;align-items: center">
        <div>广告标题：</div>
        <el-input v-model="title" style="width: 200px;margin-right: 10px" size="small" placeholder="请输入广告标题"></el-input>
        <div>所属城市：</div>
        <el-select style="width: 200px;margin-right: 10px" size="small" v-model="areaCode" placeholder="请选择所属城市"
                   clearable>
          <el-option
              v-for="item in areaData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
        <div style="margin-left: 10px">所属页面：</div>
        <el-select style="width: 200px;margin-right: 10px" size="small" v-model="menuId" placeholder="请选择所属页面"
                   clearable>
          <el-option
              v-for="item in [{name:'首页',id:1},{name:'政务号',id:2},{name:'企业号',id:3},{name:'大V号',id:4},{name:'话题页',id:5},{name:'新闻详情页',id:6}]"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
        <el-button size="small" type="primary" @click="searchBtn">查询</el-button>
        <el-button size="small" type="danger" @click="resetBtn">重置</el-button>
        <el-button size="small" type="success" @click="addBtn">新增</el-button>
        <el-button v-if="multipleSelection&&multipleSelection.length" @click="batchDeleteBtn" size="small" type="danger">批量删除</el-button>
      </div>

      <el-table
          size="small"
          tooltip-effect="dark"
          ref="multipleTable"
          :data="tableData"
          @selection-change="handleSelectionChange"
          border
          style="width: 100%;margin-top: 30px"
      >
        <el-table-column
            type="selection"
            align="center"
            width="55">
        </el-table-column>
        <el-table-column label="封面图" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.type !== 2" style="display: flex;align-items: center;justify-content: center">
              <el-image
                  style="width: 60px; height: 60px"
                  :src="scope.row.img_url"
                  :preview-src-list="scope.row.img_urlList">
              </el-image>
            </div>
            <div v-else>暂无</div>
          </template>
        </el-table-column>
        <el-table-column label="广告标题" width="230" align="center">
          <template slot-scope="scope">
            <a-tooltip placement="right" trigger="click">
              <template slot="title">
                {{scope.row.title}}
              </template>
              <span style="width:210px;height:70px;display: -webkit-box;-webkit-box-orient: vertical;text-overflow: ellipsis;-webkit-line-clamp: 3;overflow : hidden;">{{ scope.row.title }}</span>
            </a-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="广告链接" width="230" align="center">
          <template slot-scope="scope">
            <a-tooltip placement="right" trigger="click">
              <template slot="title">
                {{scope.row.link_to}}
              </template>
              <span style="width:210px;height:70px;display: -webkit-box;-webkit-box-orient: vertical;text-overflow: ellipsis;-webkit-line-clamp: 3;overflow : hidden;">{{ scope.row.link_to }}</span>
            </a-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="所属城市" width="100" prop="area_name" align="center"></el-table-column>
        <el-table-column label="所属页面" width="100" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.menu_id === '1'">首页</div>
            <div v-else-if="scope.row.menu_id === '2'">政务号</div>
            <div v-else-if="scope.row.menu_id === '3'">企业号</div>
            <div v-else-if="scope.row.menu_id === '4'">大V号</div>
            <div v-else-if="scope.row.menu_id === '5'">话题页</div>
            <div v-else-if="scope.row.menu_id === '6'">新闻详情页</div>
          </template>
        </el-table-column>
        <el-table-column label="开始时间" prop="start_date" width="100" align="center"></el-table-column>
        <el-table-column label="结束时间" prop="end_date" width="100" align="center"></el-table-column>
        <el-table-column label="数据流位置" prop="stream_number" width="100" align="center"></el-table-column>
        <el-table-column label="权重" width="180" prop="sortTime" align="center"></el-table-column>
        <el-table-column
            align="center"
            label="操作"
            width="300"
        >
          <template slot-scope="scope">
            <el-button size="small" type="primary" v-if="scope.row.type === 2" @click="playBtn(scope.row)">播放视频</el-button>
            <el-button size="small" type="success" @click="editBtn(scope.row)">修改</el-button>
            <el-button size="small" type="danger" @click="deleteBtn(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          style="display: flex;justify-content: center;margin-top: 20px"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalElements">
      </el-pagination>

    </el-card>


    <a-modal
        :visible="addDialogState"
        cancel-text="取消"
        ok-text="确认"
        :title="dialogTitle"
        width="500px"
        @cancel="addCancel"
        @ok="addSubmit('ruleForm')"
    >
      <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="small-space"
          label-position="right"
          label-width="120px"
      >
        <el-form-item label="广告标题" prop="title">
          <el-input v-model="ruleForm.title" style="width: 300px" size="small" placeholder="请输入广告标题"></el-input>
        </el-form-item>
        <el-form-item label="广告链接" prop="linkTo">
          <el-input v-model="ruleForm.linkTo" style="width: 300px" size="small" placeholder="请输入广告链接"></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="startDate">
          <el-date-picker
              size="small"
              style="width: 300px"
              v-model="ruleForm.startDate"
              format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endDate">
          <el-date-picker
              size="small"
              style="width: 300px"
              v-model="ruleForm.endDate"
              format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="所属城市" prop="areaCode">
          <el-select style="width: 300px" size="small" v-model="ruleForm.areaCode" placeholder="请选择所属城市">
            <el-option
                v-for="item in areaData"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属页面" prop="menuId">
          <el-select style="width: 300px;" size="small" v-model="ruleForm.menuId" placeholder="请选择所属页面"
                     clearable>
            <el-option
                v-for="item in [{name:'首页',id:'1'},{name:'政务号',id:'2'},{name:'企业号',id:'3'},{name:'大V号',id:'4'},{name:'话题页',id:'5'},{name:'新闻详情页',id:'6'}]"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="ruleForm.menuId === '6'" label="位置" prop="location">
          <el-select style="width: 300px;" size="small" v-model="ruleForm.location" placeholder="请选择位置"
                     clearable>
            <el-option
                v-for="item in [{name:'文章上方',id:1},{name:'文章下方',id:2}]"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select style="width: 300px;" size="small" v-model="ruleForm.type" placeholder="请选择类型"
                     clearable>
            <el-option
                v-for="item in [{name:'图片',id:1},{name:'视频',id:2},{name:'第三方广告',id:16}]"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否可转发" prop="shareFlag">
          <el-select style="width: 300px;" size="small" v-model="ruleForm.shareFlag" placeholder="请选择"
                     clearable>
            <el-option
                v-for="item in [{name:'否',id:0},{name:'是',id:1}]"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据流位置" prop="streamNumber">
          <el-input-number v-model="ruleForm.streamNumber" size="small" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item v-if="ruleForm.type !== 2" label="封面图" prop="imgUrl">
          <el-upload
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess"
              :show-file-list="false"
              :action="uploadApiUrl"
              class="avatar-uploader">
            <img v-if="ruleForm.imgUrl" :src="ruleForm.imgUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="ruleForm.type === 2" label="视频" prop="imgUrl">
          <el-upload
              class="upload-demo"
              :action="uploadApiUrl"
              :on-success="videoUploadSuccess"
              :on-remove="videoUploadRemove"
              multiple
              :file-list="videoData"
              :limit="1">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传视频文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
      </el-form>
    </a-modal>

    <!--    删除的弹窗-->
    <a-modal
        title="提示"
        :visible="deleteDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="deleteCancel"
        @ok="deleteSubmit"
    >
      <div>{{ simpleDelete ? '是否删除该条记录？' : '是否删除当前所选中的记录？' }}</div>
    </a-modal>


    <a-modal
        :visible="videoDialogState"
        title="视频"
        width="1200px"
        @cancel="videoDialogCancel"
    >
      <template slot="footer">
        <a-button key="back" v-show="false">
          Return
        </a-button>
        <a-button @click="videoDialogCancel" key="submit" v-show="true">
          关闭
        </a-button>
      </template>
      <video-player class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions">
      </video-player>
    </a-modal>
  </div>
</template>

<script>
import {baseURL} from "@/api/config";
import moment from "moment";

export default {
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  data() {
    return {
      areaCode: null,
      menuId: null,
      title: null,
      pageNum: 1,
      pageSize: 10,
      tableData: [],
      totalElements: 0,
      addDialogState: false,
      dialogTitle: '',
      uploadApiUrl: '',
      ruleForm: {
        id: null,
        title: '',
        linkTo: '',
        startDate: '',
        endDate: '',
        examineStatus: '1',
        imgUrl: '',
        menuId: '',
        areaCode: '',
        location: '',
        type: '',
        streamNumber: '',
        shareFlag: null
      },
      rules: {
        title: [{required: true, message: "请输入广告标题", trigger: "blur"}],
        linkTo: [{required: true, message: "请输入广告链接", trigger: "blur"}],
        startDate: [{required: true, message: "请选择开始时间", trigger: "blur"}],
        endDate: [{required: true, message: "请选择结束时间", trigger: "blur"}],
        imgUrl: [{required: true, message: "请上传文件", trigger: "blur"}],
        menuId: [{required: true, message: "请选择所属页面", trigger: "blur"}],
        areaCode: [{required: true, message: "请选择所属城市", trigger: "blur"}],
        location: [{required: true, message: "请选择位置", trigger: "blur"}],
        type: [{required: true, message: "请选择类型", trigger: "blur"}],
        shareFlag: [{required: true, message: "请选择是否可转发", trigger: "blur"}],
        streamNumber: [{required: true, message: "请输入数据流位置", trigger: "blur"}],
      },
      areaData: [],
      simpleDelete: false,
      deleteId: null,
      deleteDialogState: false,
      multipleSelection: [],
      videoData: [],
      videoDialogState:false,
      playerOptions: {
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: 'auto',
        language: 'zh-CN',
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: '16:9',
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [{
          //类型
          type: "video/mp4",
          //url地址
          src: ''
        }],
        //你的封面地址
        poster: '',
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true
        }
      }
    }
  },
  created() {
    this.uploadApiUrl = baseURL + '/file/uploadAdFile'
    this.getList()
    this.postAxios("/examine/special/getAllOpenUpArea", {}).then(res => {
      if (res && res.success) {
        this.areaData = res.content
      }
    })
  },
  methods: {
    videoDialogCancel(){
      this.player.pause()
      this.videoDialogState = false
    },
    videoUploadSuccess(res) {
      if (res.success) {
        this.ruleForm.imgUrl = res.entity
      }
    },
    videoUploadRemove() {
      this.videoData = []
      this.ruleForm.imgUrl = ''
    },
    searchBtn() {
      this.getList()
    },
    resetBtn() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.title = null
      this.areaCode = null
      this.menuId = null
      this.getList()
    },
    addBtn() {
      this.dialogTitle = '新增广告'
      this.ruleForm = {
        id: null,
        title: '',
        linkTo: '',
        startDate: '',
        endDate: '',
        examineStatus: '1',
        imgUrl: '',
        menuId: '',
        areaCode: '',
        location: '',
        type: '',
        streamNumber: '',
      }
      this.addDialogState = true
    },
    deleteBtn(row) {
      this.simpleDelete = true
      this.deleteId = row.id
      this.deleteDialogState = true
    },
    playBtn(row){
      this.playerOptions.sources[0].src = row.img_url
      this.videoDialogState = true
    },
    editBtn(row) {
      this.dialogTitle = '编辑广告'
      this.ruleForm.id = row.id
      this.ruleForm.title = row.title
      this.ruleForm.linkTo = row.link_to
      this.ruleForm.startDate = row.start_date
      this.ruleForm.endDate = row.end_date
      this.ruleForm.examineStatus = '1'
      this.ruleForm.menuId = row.menu_id
      this.ruleForm.areaCode = row.area_code
      this.ruleForm.location = row.location
      this.ruleForm.type = row.type
      this.ruleForm.streamNumber = row.stream_number
      this.ruleForm.shareFlag = row.share_flag
      if (this.ruleForm.type === 2){
        this.videoData = []
        this.videoData.push({url: row.img_url, name: '视频文件'})
        this.ruleForm.imgUrl = row.img_url
      } else {
        this.ruleForm.imgUrl = row.img_url
      }
      this.addDialogState = true
    },
    batchDeleteBtn() {
      this.simpleDelete = false
      this.deleteDialogState = true
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    deleteCancel() {
      this.deleteDialogState = false
    },
    deleteSubmit() {
      if (this.simpleDelete) {
        //单个删除
        this.postAxios("/ad/delete", [
          this.deleteId
        ]).then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.getList()
          }
        })
      } else {
        //多个删除
        let ids = []
        this.multipleSelection.forEach((item) => {
          ids.push(item.id)
        })
        this.postAxios("/ad/delete", ids).then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.getList()
          }
        })
      }
    },
    getList() {
      this.postAxios("/ad/list", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        areaCode: this.areaCode ? this.areaCode : null,
        menuId: this.menuId ? this.menuId : null,
        title: this.title ? this.title : null
      }).then(res => {
        if (res && res.success) {
          res.content.forEach((item) => {
            item.img_urlList = []
            if (item.img_url) {
              item.img_urlList.push(item.img_url)
            }
            item.sortTime = ''
            if (item.sort) {
              item.sortTime = moment(item.sort * 1000).format('YYYY-MM-DD HH:mm:ss')
            }
          })
          this.tableData = res.content
          this.totalElements = res.totalCount
        } else {
          this.tableData = []
          this.totalElements = 0
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
    handleAvatarSuccess(res) {
      console.log(res, 'res')
      if (res.success) {
        this.ruleForm.imgUrl = res.entity;
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    addCancel() {
      this.addDialogState = false
      this.$refs.ruleForm.clearValidate();
    },
    addSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle === '新增广告') {
            this.ruleForm.startDate = moment(this.ruleForm.startDate).format('yyyy-MM-DD')
            this.ruleForm.endDate = moment(this.ruleForm.endDate).format('yyyy-MM-DD')
            this.postAxios("/ad/insert", this.ruleForm).then(res => {
              this.$message.success("添加成功!");
              this.addDialogState = false
              this.getList()
            })
          } else {
            this.ruleForm.startDate = moment(this.ruleForm.startDate).format('yyyy-MM-DD')
            this.ruleForm.endDate = moment(this.ruleForm.endDate).format('yyyy-MM-DD')
            this.postAxios("/ad/update", this.ruleForm).then(res => {
              this.$message.success("修改成功!");
              this.addDialogState = false
              this.getList()
            })
          }
        }
      });
    },
  }
}
</script>

<style scoped>

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
